import React from 'react';

export interface DocumentProps {
  width?: string;
  height?: string;
  color?: string;
}

const Document: React.FC<DocumentProps> = (props): JSX.Element => {
  return (
    <svg width="37" height="37" viewBox="0 0 37.622 37.622">
      <path
        fill="#959595"
        d="M37.306,27.558c-1.339-2.418-7.203-3.958-12.381-4.25c-0.468-0.501-0.943-1.028-1.43-1.582
		c-4.45-5.088-6.252-12.482-6.925-16.399c-0.08-0.83-0.168-1.52-0.242-2.034c-0.06-0.409-0.186-1.262-1.073-1.262
		c-0.284,0-0.558,0.122-0.753,0.339c-0.316,0.361-0.269,0.749-0.213,1.197c0.063,0.514,0.158,1.202,0.293,1.987
		c0.379,3.977,0.558,11.549-2.503,17.564c-0.319,0.627-0.637,1.229-0.953,1.803c-5.728,1.666-10.35,4.637-11.027,7.101
		c-0.245,0.892-0.032,1.747,0.601,2.409c0.737,0.77,1.607,1.16,2.586,1.16c2.71,0,5.799-3.018,9.181-8.967
		c1.506-0.396,3.001-0.672,4.446-0.818c0.563-0.057,1.474-0.176,2.034-0.262c1.543-0.238,3.289-0.334,5.083-0.275
		c4.152,4.316,7.547,6.504,10.091,6.504c1.366-0.001,2.497-0.667,3.183-1.875C37.726,29.15,37.728,28.318,37.306,27.558z
		 M3.285,33.591c-0.424,0-0.786-0.172-1.141-0.543c-0.145-0.151-0.177-0.281-0.117-0.495c0.349-1.269,3.281-3.444,7.566-5.023
		C7.172,31.35,4.855,33.591,3.285,33.591z M18.64,23.57c-0.532,0.082-1.396,0.194-1.93,0.25c-0.971,0.096-1.969,0.249-2.976,0.455
		c0.042-0.082,0.084-0.165,0.126-0.248c1.501-2.949,2.431-6.485,2.775-10.538c1.377,3.854,3.173,7.06,5.354,9.554
		c0.064,0.074,0.131,0.149,0.195,0.225C20.925,23.298,19.737,23.401,18.64,23.57z M35.56,28.916
		c-0.332,0.588-0.804,0.861-1.481,0.861h-0.001c-1.59,0-4.035-1.505-6.962-4.265c4.53,0.569,7.847,1.94,8.442,3.015
		C35.644,28.683,35.644,28.766,35.56,28.916z"
      />
    </svg>
  );
};
export default Document;
